import { render, staticRenderFns } from "./noodAseg.vue?vue&type=template&id=1db7f9f8&scoped=true"
import script from "./noodAseg.vue?vue&type=script&lang=js"
export * from "./noodAseg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db7f9f8",
  null
  
)

export default component.exports